const CABLE_SPECS = [
  { size: "16 sq.mm", current: "135 A", weight: "180 kg/km" },
  { size: "25 sq.mm", current: "180 A", weight: "275 kg/km" },
  { size: "35 sq.mm", current: "225 A", weight: "375 kg/km" },
  { size: "50 sq.mm", current: "285 A", weight: "525 kg/km" },
  { size: "70 sq.mm", current: "355 A", weight: "730 kg/km" },
  { size: "95 sq.mm", current: "430 A", weight: "990 kg/km" },
];

export const Specifications = () => {
  return (
    <section
      id="specifications"
      data-testid="specifications-section"
      className="relative bg-[#0B0E12] py-24 md:py-32 border-t border-[#F5F1EA]/8"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left intro */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-brand-red" />
              <span data-testid="specs-eyebrow" className="text-xs uppercase tracking-[0.32em] text-brand-red font-medium">
                Technical Specifications
              </span>
            </div>
            <h2
              data-testid="specs-heading"
              className="font-display font-semibold tracking-tight text-[#F5F1EA] text-3xl md:text-4xl lg:text-5xl leading-[1.05]"
            >
              Engineered to <br />
              <span className="text-brand-red italic font-medium">Precise Standards.</span>
            </h2>
            <p className="mt-6 text-base text-[#A8A29A] leading-relaxed max-w-md">
              Standard welding cable sizes manufactured to ISI specifications. Custom sizes and bulk lengths available on order.
            </p>

            <div className="mt-10 space-y-4">
              {[
                { label: "Conductor", value: "Electrolytic Copper / EC Grade Aluminium" },
                { label: "Insulation", value: "TRS / HOFR / EPR / PCP Rubber Compound" },
                { label: "Voltage Rating", value: "100 V (Up to 600 V)" },
                { label: "Standard", value: "IS 9857 — BIS Certified" },
              ].map((spec, i) => (
                <div
                  key={i}
                  data-testid={`tech-spec-${i}`}
                  className="flex items-start gap-4 border-l-2 border-brand-red/40 pl-4 py-1"
                >
                  <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-[0.3em] text-[#A8A29A]/70 mb-1">{spec.label}</div>
                    <div className="text-sm text-[#F5F1EA]">{spec.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Specs table */}
          <div className="lg:col-span-7">
            <div className="bg-[#0E1116] border border-[#F5F1EA]/10">
              {/* Table header */}
              <div className="grid grid-cols-3 gap-4 p-5 border-b border-[#F5F1EA]/10 bg-[#161A21]">
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-medium">Cable Size</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-medium">Current Rating</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-medium">Approx Weight</div>
              </div>
              {/* Rows */}
              {CABLE_SPECS.map((spec, i) => (
                <div
                  key={i}
                  data-testid={`spec-row-${i}`}
                  className="grid grid-cols-3 gap-4 p-5 border-b border-[#F5F1EA]/8 last:border-b-0 hover:bg-[#161A21]/60 transition-colors"
                >
                  <div className="font-display text-base md:text-lg text-[#F5F1EA] font-medium">{spec.size}</div>
                  <div className="text-sm text-[#F5F1EA]/80 self-center">{spec.current}</div>
                  <div className="text-sm text-[#A8A29A] self-center">{spec.weight}</div>
                </div>
              ))}
            </div>

            <div className="mt-6 text-xs text-[#A8A29A]/70 leading-relaxed">
              * Values indicative. Final specifications confirmed at order based on application requirements.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
